import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Modal, ModalControlModalProps, Text } from '@frontend/design-system';

export const EditDeviceModal: FC<React.PropsWithChildren<ModalControlModalProps>> = (modalProps) => {
  const { t } = useTranslation('phone', { keyPrefix: 'call-groups' });

  return (
    <Modal {...modalProps}>
      <Modal.Header textAlign='center'>{t('Editing Devices')}</Modal.Header>
      <Modal.Body
        style={{
          overflow: 'visible',
        }}
      >
        <Text>
          {t(
            'You may only edit devices assigned to your current location. To edit a device at another location, log into that location.'
          )}
        </Text>
      </Modal.Body>
      <Modal.Actions onPrimaryClick={modalProps.onClose} primaryLabel={t('Okay')} />
    </Modal>
  );
};
